module.exports = __webpack_public_path__ + "img/office-expenses-icon.db185c0c.svg";